import { factoryModels } from '@/data/factoryModels'
import VueModelFactory from 'vue-model-factories'
import _ from 'lodash'

const factory = new VueModelFactory().define(factoryModels).build()


export const clientBidService = (client) => {
    let _client = client
    let _id

    return {
        for (id) {
            _id = id
            return this
        },

        all: async () => {
            return await client.get(`${process.env.VUE_APP_API_URL}/cases/${_id}/bids`)
        },

        get: async (id) => {
            return await client.get(`${process.env.VUE_APP_API_URL}/cases/${_id}/bids/${id}`)
        }
    }
}